// src/render/interpolation.ts — pure lerp helper consumed by the render
// interpolation pass. Sim runs at 30 Hz; the render layer interpolates between
// the last-two sim snapshots each frame to produce smooth motion (alpha in [0,1]).

import type { Vec2 } from '../shared/types/intent';

/**
 * Linear interpolation between two points. Alpha is clamped to [0,1] so a
 * late-frame overflow in the accumulator (e.g., a long GC pause) never pushes
 * the rendered position past the next sim snapshot.
 */
export function lerp(prev: Vec2, curr: Vec2, alpha: number): Vec2 {
  const a = alpha < 0 ? 0 : alpha > 1 ? 1 : alpha;
  return {
    x: prev.x + (curr.x - prev.x) * a,
    y: prev.y + (curr.y - prev.y) * a,
  };
}
